module.exports = __webpack_public_path__ + "static/img/8.b79b7b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/8.png
// module id = 0y2I
// module chunks = 0